import { useContext } from 'react';
import { AppStateContext } from '../../providers/AppStateProvider';

export default function useAppState() {
  return useContext(AppStateContext);
}
